<template>
    <div v-if="errorMessage" class="error-banner-wrapper">
        <div class="error-banner-placeholder"></div>
        <div :class="bannerStyles" class="error-banner">
            <div class="inner-wrapper">
                <span class="icon error-icon-white"></span>
                <p>{{errorMessage}}</p>
            </div>
        </div>
    </div>
</template>
<script src="./top-error-message.js">